<template>
  <div class="rich-text">
    <div class="element" v-for="element in elements" :key="element.id" :class="element.props.meta">
      <div :class="{ container: isRoot }">
        <div :class="{ columns: isRoot }" :style="hasStyle ? element.props.style: {}">

          <a :class="{ column: isRoot }"
            v-if="element.type === 'AtomText' && element.props.link"
            class="child text"
            :href="element.props.link">
            <h2 v-if="element.props.style.fontSize === '200%'" v-html="element.props.text"></h2>
            <h3 v-else-if="element.props.style.fontSize === '150%'" v-html="element.props.text"></h3>
            <span v-else v-html="element.props.text"></span>
          </a>

          <div :class="{ column: isRoot }" v-else-if="element.type === 'AtomText'" class="child text">
            <h2 v-if="element.props.style.fontSize === '200%'" v-html="element.props.text"></h2>
            <h3 v-else-if="element.props.style.fontSize === '150%'" v-html="element.props.text"></h3>
            <span v-else v-html="element.props.text"></span>
          </div>

          <div :class="{ column: isRoot }" v-else-if="element.type === 'AtomImage'" class="child image">
            <img :src="getImage(element.props.source)" alt="">
          </div>


          <div :class="{ column: isRoot }" v-else-if="element.type === 'AtomGrid'"
            v-for="column in element.props.columns" :key="column.id" class="child grid">
            <rich-text :elements="column.atoms" :key="`rt-${column.id}`"></rich-text>
          </div>

          <div :class="{ column: isRoot }" v-else-if="element.type === 'AtomGrid'"
            v-for="column in element.props.columns" :key="column.id" class="child grid">
            <rich-text :elements="column.atoms" :key="`rt-${column.id}`"></rich-text>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import RichText from '@/components/RichText.vue';

export default {
  name: 'rich-text',
  props: ['elements', 'isRoot', 'hasStyle'],
  components: {
    RichText,
  },
  data() {
    return {
    };
  },
  methods: {
    getImage(source) {
      return api.getImage(source);
    },
  },
};
</script>

<style lang="sass">
.voeux2019
  img
    width: auto
.rich-text
  h2
    color: #032f56
    text-transform: uppercase
    font-size: 2rem
    font-weight: 600
    font-family: Raleway,Lato,sans-serif

.title
  .rich-text
    position: relative
  h2
    position: relative
    display: inline-block
    margin-bottom: 4.5rem
    &::after
      content: ""
      position: absolute
      left: 0
      bottom: -1.5rem
      height: 4px
      width: 60px
      background-color: #fe3904
  &.center
    text-align: center

</style>
